import {
  Text,
  View,
  Pressable,
  ActivityIndicator,
} from 'react-native'
import React, { FunctionComponent } from 'react'

import { UniversalWebView } from '../../components/UniversalWebView'

import styles from './Password.styles'
import { stdCouleurBleu } from '@commonStyle';

export const Password: FunctionComponent<{ onBack: () => void }> = ({ onBack }) => {
  return (
    <View style={styles.container}>
      <View style={styles.passwordResetContainer}>
        <UniversalWebView
          source={{ uri: 'https://password.jvsonline.fr/password/forgot?service=https%3A//emu-hc.jvsonline.fr/' }}
          style={styles.webView}
          javaScriptEnabled={true}
          domStorageEnabled={true}
          startInLoadingState={true}
          scalesPageToFit={true}
          //injectedJavaScript={injectedJavaScript}
          renderLoading={() => (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={stdCouleurBleu} />
              <Text style={styles.loadingText}>Chargement...</Text>
            </View>
          )}
          onError={(event) => {
            console.warn('WebView error:', event);
          }}
          onHttpError={(event) => {
            console.warn('WebView HTTP error:', event);
          }}
        />
        <View style={styles.backButtonContainer}>
          <Pressable style={styles.backButton} onPress={onBack}>
            <Text style={styles.backButtonText}>Retour</Text>
          </Pressable>
        </View>
      </View>
    </View>
  );
};
